import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SpacingValue } from '@frk/eds-components';
import { AppStateService } from '@services';
import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';
import { Logger } from '@utils/logger';
import { LinkService } from '@services/link.service';

/**
 * Logger
 */
const logger = Logger.getLogger('IndexCardsComponent');

/**
 * Interface for the Index Cards
 */
interface IndexCards {
  indexCard: IndexCard[];
}

/**
 * Interface for the Index Cards
 */
interface IndexCard {
  title: any;
  displayText: string;
  url: string;
  summary: string;
}

/**
 * The Index Cards component can be used to display a list of links either from the sitemap or
 * a custom document type.
 *
 * Selector: `ft-index-cards`
 *
 * Exported as: `IndexCardsComponent`
 */
@Component({
  selector: 'ft-index-cards',
  templateUrl: './index-cards.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IndexCardsComponent
  extends AbstractBaseComponent
  implements OnInit {
  /**
   * Array
   */
  indexCards: IndexCard[];

  colNumbers: any;

  /**
   * Constructor
   */
  constructor(
    private router: Router,
    private appStateService: AppStateService,
    private linkService: LinkService
  ) {
    super();
  }

  /**
   * On initialisation
   */
  ngOnInit() {
    super.ngOnInit();
    this.indexCards = this.getIndexCards();
    if (this.container !== 'container') {
      // 4 = 100%, 5 = 0.625%, 6 = 50%
      this.colNumbers = { s: 4, m: 8, l: 5 };
    } else {
      this.colNumbers = { s: 4, m: 8, l: 4 };
    }
  }

  /**
   * Read the content from the document
   */
  get content() {
    return this.document?.getData<IndexCards>();
  }

  /**
   * Get Margin Bottom
   */
  get marginBottom(): SpacingValue | 'auto' {
    return this.component.getParameters()?.marginBottom
      ? this.component.getParameters()?.marginBottom
      : 'xxxl';
  }

  /**
   * The array of links to display
   */
  getIndexCards(): IndexCard[] {
    logger.debug('here');
    const linksToDisplay = this.component.getParameters().linksToDisplay;
    let indexCards = this.component.getModels()?.IndexCards;

    // Read document instead of sitemap
    if (linksToDisplay === 'Document') {
      indexCards = this.content?.indexCard;
    }

    if (indexCards) {
      for (const card of indexCards) {
        if (!card.title) {
          indexCards = indexCards.filter((item) => item !== card);
        }
        if (card.title?.linkCollection?.length) {
          card.title = card.title.linkCollection[0];
          card.title.url = this.linkService.getCTALink(
            this.page,
            card.title,
            this.appStateService?.getHomePageUrl()
          );
        }
      }
    }

    return indexCards;
  }
}
